'use strict';

exports.isValidEmailRegExp = /[\w\.=-]+@[\w\.-]+\.[\w]{2,3}/;
